import { Fragment, useEffect, useState } from "react";
import SEO from "../../components/seo";
import LayoutTwo from "../../layouts/LayoutTwo";
import authImage from "../../assets/images/Auth/auth_bg.png";
import { Link, useNavigate } from "react-router-dom";
import { apiInstance } from "../../helpers/axios";
import LoadingSpinner from "../../components/loading/LoadingSpinner";
import Cookies from "js-cookie";
import OTPInput from "react-otp-input";
import toast from "react-hot-toast";

const formInputData = { username: "", type: "email", otp: "" };

const apiUrl = "/Customer/LoginWithOTP";
const verifyOtpUrl = "/Customer/VerifyLogin";

const Login = () => {
  const [formData, setFormData] = useState(formInputData);
  const [loading, setLoading] = useState(false);
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    let timer;
    if (resendTimer > 0) {
      timer = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [resendTimer]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const sendOTP = (e) => {
    e.preventDefault();
    if (!formData.username) {
      toast.error("Please enter your email.");
      return;
    }
    setLoading(true);

    apiInstance
      .post(apiUrl, { username: formData.username, type: formData.type })
      .then((response) => {
        const data = response.data;
        if (data.Status === true) {
          toast.success(data.Message);
          setTimeout(() => {
            setShowOtpInput(true);
            setResendTimer(formData.type === "wa" ? 300 : 60);
          }, 1000);
        } else {
          toast.error(data.Message);
        }
      })
      .catch(() => toast.error("Error occurred while sending OTP"))
      .finally(() => setLoading(false));
  };

  const verifyOTP = (e) => {
    e.preventDefault();
    if (formData.otp.length !== 6) {
      toast.error("Please enter a valid OTP.");
      return;
    }
    setLoading(true);

    apiInstance
      .post(verifyOtpUrl, { username: formData.username, OTP: formData.otp })
      .then((response) => {
        const data = response.data;

        if (data.Status === true) {
          toast.success("OTP Verified Successfully!");
          Cookies.set("kalista-webtoken", data.AccessToken, {
            expires: 7,
            secure: true,
            sameSite: "Strict",
          });
          Cookies.set("kalista-web-Id", data.Data.Code, {
            expires: 7,
            secure: true,
            sameSite: "Strict",
          });
          Cookies.set("kalista-web-user", JSON.stringify(data.Data), {
            expires: 7,
            secure: true,
            sameSite: "Strict",
          });
          setFormData(formInputData);
          navigate("/orders");
          console.log(response);

          window.location.reload();
        } else {
          toast.error(data.Message);
        }
      })
      .catch(() => toast.error("Error occurred while verifying OTP"))
      .finally(() => setLoading(false));
  };

  const resetLoginForm = () => {
    setResendTimer(0);
    setFormData(formInputData);
    setShowOtpInput(false);
    setLoading(false);
  };

  const formatResendTimer = () => {
    if (resendTimer > 0) {
      if (formData.type === "wa") {
        const minutes = Math.floor(resendTimer / 60);
        const seconds = resendTimer % 60;
        return `Resend OTP in ${minutes}:${seconds
          .toString()
          .padStart(2, "0")} minutes`;
      } else {
        return `Resend OTP in ${resendTimer}s`;
      }
    }
    return "Resend OTP";
  };

  return (
    <Fragment>
      <SEO titleTemplate="Login" />
      <LayoutTwo>
        {loading && <LoadingSpinner />}
        <div className="container">
          <div className="auth_con sign_in">
            <div className="content_con">
              <h1 className="heading">Sign In</h1>
              <p className="desc">
                Please enter your email ID to receive an OTP via email or
                WhatsApp
              </p>

              {/* login form */}
              <form onSubmit={showOtpInput ? verifyOTP : sendOTP}>
                <div className="input_grid">
                  <input
                    name="username"
                    type="email"
                    id="login_username"
                    placeholder="Email Id"
                    value={formData.username}
                    onChange={handleInputChange}
                    className="password_input"
                    disabled={showOtpInput || loading}
                  />
                </div>
                <div className="login_type_con">
                  <label className="main_label">Receive OTP via:</label>
                  <label className="radio-option">
                    <input
                      type="radio"
                      name="type"
                      value="email"
                      checked={formData.type === "email"}
                      onChange={handleInputChange}
                      disabled={showOtpInput || loading}
                    />
                    <span>Email</span>
                  </label>
                  <label className="radio-option">
                    <input
                      type="radio"
                      name="type"
                      value="wa"
                      checked={formData.type === "wa"}
                      onChange={handleInputChange}
                      disabled={showOtpInput || loading}
                    />
                    <span>WhatsApp</span>
                  </label>
                </div>

                <div
                  className={`otp_input_container ${showOtpInput ? "show" : ""
                    }`}
                >
                  <div className="otp_input_inner">
                    <label htmlFor="login_email">OTP</label>
                    <OTPInput
                      value={formData.otp}
                      onChange={(otp) =>
                        setFormData((prev) => ({ ...prev, otp }))
                      }
                      numInputs={6}
                      inputType="number"
                      renderInput={(props) => (
                        <input {...props} disabled={loading} />
                      )}
                    />
                    <div className="otp_btn_con">
                      <span
                        onClick={resendTimer === 0 ? sendOTP : null}
                        className={`resend_btn ${resendTimer > 0 ? "disabled" : ""
                          }`}
                      >
                        {formatResendTimer()}
                      </span>
                      <span className="reset_btn" onClick={resetLoginForm}>
                        Reset Form
                      </span>
                    </div>
                  </div>
                </div>

                <button
                  className="button primary_btn submit_btn"
                  type="submit"
                  disabled={loading || !formData.username}
                >
                  {showOtpInput ? "Verify OTP" : "Send OTP"}
                </button>
              </form>

              <div className="divider_div">
                <span>OR</span>
                <span></span>
              </div>
              <div className="auth_login_link">
                New to Kalista Jewels?
                <Link to="/register">Create a New Account</Link>
              </div>
            </div>
            <div className="banner_con">
              <img src={authImage} alt="register" />
            </div>
          </div>
        </div>
      </LayoutTwo>
    </Fragment>
  );
};

export default Login;
